import { render, staticRenderFns } from "./RequestPasswordResetView.vue?vue&type=template&id=1583f2af&"
import script from "./RequestPasswordResetView.vue?vue&type=script&lang=ts&"
export * from "./RequestPasswordResetView.vue?vue&type=script&lang=ts&"
import style0 from "./RequestPasswordResetView.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports